"use strict";

var SolrCollection = require('bunsen/collections/SolrCollection');
var Transactions = module.exports = SolrCollection.extend();

var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var Transaction = require('bunsen/models/ecomm/Transaction');
var Party = require('bunsen/models/Party');
var endpoints = require('dibs-endpoints');
var root = typeof window === 'undefined' ? global : window;

// root.bunsen for console debugging
root.bunsen = root.bunsen || {};
root.bunsen.Transactions = Transactions;

_.extend(Transactions.prototype, {
    model: Transaction,
    url : endpoints.transactionsSolr(),
    params: {},
    defaultParams: {
        pageStart: 0,
        pageSize: 15,
        sort: 'createdDate desc'
    },

    /**
     * @memberof bunsen.Transactions
     * @param models
     * @param [options]
     */
    initialize : function (models, options) {
        this.options = options;
        this.resetParams();
    },
    inflateItems : function (fields) {
        var items = this.pluck('item');
        var fetches = [];

        _.each(items, function (item) {
            fetches.push(item.fetch({
                data: {
                    fields : fields || 'classification,measurement,condition,basic'
                }
            }));
        });
        return fetches;
    },
    /**
     * adds a "sameItemTransactions" property to each transaction with the
     * number of transactions that exist for the same item
     */
    getSameItemTransactions: function (options) {
        var searchTransactions = new Transactions();
        var self = this;
        var sellerId = this.getParam('sellerId', {filterQuery: true});
        var deferred = new $.Deferred();
        var itemIds = this.pluck('item.id').join(" ");

        // Only run this if there are actually some items (collection isn't empty)
        if (itemIds === '') {
            return null;
        }

        searchTransactions.setParam('viewName', 'dealer.preConfirmation');
        searchTransactions.setParam('itemId', itemIds, {filterQuery: true});
        searchTransactions.setParam('inflate', false);

        // Limit results to the current seller if we are already filtering by seller
        if (sellerId) {
            searchTransactions.setParam('sellerId', sellerId, {filterQuery: true});
        }

        $.when(searchTransactions.fetchWithParameters(options)).done(function () {
            var byId = searchTransactions.groupBy('item.id');
            self.each(function (transaction) {
                var itemId = transaction.get('item.id');
                if (byId[itemId]) {
                    transaction.sameItemTransactions = byId[itemId].length;
                } else {
                    transaction.sameItemTransactions = null;
                }
            });
            deferred.resolve();
        }).fail(function () {
            deferred.reject();
        });
        return deferred;
    },

    /**
     * adds conversations to a transaction depending on buyerId and itemId
     */
    setTransactionConversations: function (conversations) {
        var uniqueId = conversations.groupBy(function (c) {
            var buyerId = c.get('members').findWhere({ userType: Party.ROLE_BUYER }).get('user.id');
            return c.get('item.id') + buyerId;
        });
        this.forEach(function (transaction) {
            var itemId = transaction.get('item.id');
            var buyerId = transaction.get('buyer.id');
            if (uniqueId[itemId + buyerId]) {
                transaction.conversation = uniqueId[itemId + buyerId].pop();
            }
        });
        this.trigger('added:conversations');
    }
});

_.extend(Transactions, {
    /**
     * Check if the buyer has any private offers for this item
     * return a private offer transaction or a rejected promise if expired
     */
    fetchExistingOffer: function (itemId, buyerId) {
        var transactions = new Transactions();
        var transaction;
        var offer;
        var isExpired;

        transactions.setParam('itemId',  itemId,  { filterQuery: true });
        transactions.setParam('buyerId', buyerId, { filterQuery: true });
        transactions.setParam('viewName', 'buyer.checkoutOffer');

        return transactions.fetchWithParameters().then(function () {
            transaction = transactions.last();
            offer = transaction && transaction.getMostRecentOffer();
            isExpired = offer && offer.isExpired();
            if (offer && !isExpired) {
                return transaction;
            }
            return $.Deferred().reject({
                transaction: transaction,
                hasPrivateOffer: !!offer,
                isExpired: isExpired
            });
        });
    },
    /**
     * Does this buyer have any other valid active transactions for this item
     * @param itemId
     * @param buyerId
     */
    fetchExistingActiveTransactions: function (itemId, buyerId) {
        var transactions = new Transactions();
        transactions.setParam('itemId',  itemId,  {filterQuery : true});
        transactions.setParam('buyerId', buyerId, {filterQuery : true});
        transactions.setParam('sort', 'createdDate desc');
        transactions.setParam('viewName', 'buyer.existingTransaction');
        return transactions.fetchWithParameters().then(function () {
            return transactions;
        });
    },
    /**
     * Does this buyer have any active offer (buyer- or dealer- initiated) or order for this item
     * @param itemId
     * @param buyerId
     */
    fetchExistingActiveOffersAndOrders: function (itemId, buyerId) {
        var transactions = new Transactions();
        transactions.setParam('itemId',  itemId,  {filterQuery : true});
        transactions.setParam('buyerId', buyerId, {filterQuery : true});
        transactions.setParam('sort', 'createdDate desc');
        transactions.setParam('viewName', 'buyer.offersAndOrders');
        return transactions.fetchWithParameters().then(function () {
            return transactions;
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/Transactions.js
// module id = 1015
// module chunks = 4 6 8 9